
<div class="w-full lg:pr-3 bar-main-container">
  <div class="hidden bar-container lg:flex lg:flex-row items-center font-rubik">
    <div class="selected-filters-container">
      <button v-for="filter in selectedFilters" :key="filter.text"
        @click="removeFilter(filter)"
        class="filter-button"
      >
        {{ filter.text }}
        <img class="inline pl-2" src="@/images/partners-page/clear.svg" :alt="`Clear ${filter.text} filter`">
      </button>
    </div>
    <div class="change-location">
      <div class="relative hidden lg:inline">
        <div class="header-input-container flex flex-row justify-around items-center">
          <input
            @keyup.enter="search()"
            v-model="query"
            class="bg-transparent w-full focus:ring-0 focus:outline-none"
            type="search"
            placeholder="Change location"
          />
          <img @click="search()" src="@/images/header/search.svg" alt="search" />
        </div>
        <!-- Dropdown container for results -->
        <div
          v-if="cities.length > 0 && query.length >= 3"
          class="absolute left-0 right-0 mt-1 border rounded-md bg-white z-10"
        >
          <div v-if="cities.length" role="menu" class="border rounded-md">
            <div class="dropdown-content modal-card-body">
              <p class="dropdown-item"><b>We found mulitple results...</b></p>
              <a v-for="city in cities" :key="city.id" :href="cityPath(city.node)" class="dropdown-item">
                {{ city.node.name }}, {{ city.node.stateId | upcase }}
              </a>
            </div>
          </div>
        </div>
        <div v-if="error" class="help py-1 text-center bg-white text-red-500 border rounded-md">
          {{ error }}
          <b><a @click.prevent="resetSearch()">Try Again</a></b>
        </div>
      </div>
    </div>
  </div>
  <div class="lg:hidden bar-container font-rubik flex justify-between px-4">
    <div class="header-input-container flex flex-row justify-around items-center">
      <img src="@/images/header/search.svg" alt="search" />
      <input
        v-model="productName"
        class="bg-transparent w-full focus:ring-0 focus:outline-none"
        type="search"
        placeholder="Search products"
      />
    </div>
    <img @click="toggleMobileFilters" class="" src="@/images/header/filters.svg" alt="filters" />
  </div>
</div>
